import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DynamicForm2 from '../Form2';


import ReactHtmlParser from 'react-html-parser';


import './index.css';


class ModalNew2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: props.showModal,
            centered: true
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        if (this.props.toggleModal) {
            if (Array.isArray(this.props.formData)) {
                this.props.formData.map(val => {
                    val.value = ''
                    if (val.validation !== undefined) {
                        if (val.validation.required) {
                            val.valid = false

                        }
                    }
                    if (val.fieldValidation) {
                        val.fieldValid = true
                    }
                })
            }
            this.props.toggleModal(!this.state.modal)
        }
        this.setState({
            modal: !this.state.modal,
        });
    }

    render() {
        const modalSize = (this.props.heading === "SET CUSTOM REPORT ACCESS" && !this.props.vviSelected) ? "lg" : undefined;



        return (
            <div>
                <Modal size={modalSize}
                    isOpen={this.state.modal}
                    centered={this.state.centered}
                >
                    <ModalHeader
                        toggle={this.toggle}
                        className="bg-black text-white text-uppercase custom-header"
                    >
                        {this.props.heading}
                    </ModalHeader>
                    <ModalBody>
                        {
                            // epic message which takes an object with {status:boolean, stringArr:['abc', 'xyz']}
                            this.props.epicMessage !== undefined &&
                            this.props.epicMessage.status &&
                            <div className="epicMessage">
                                <div className="headerMessage">
                                    <i className="fas fa-exclamation-triangle"></i>
                                    {/* <p>The Operation Could not be completed as the following assessment(s) are already Submitted</p> */}
                                </div>
                                {
                                    this.props.epicMessage.stringArr.map(val => (
                                        <p className="emailMessage">{val}</p>
                                    ))
                                }
                            </div>
                        }
                        {
                            this.props.viewMessage.map(val => {
                                return <p style={{ display: 'flex', justifyContent: "center", alignItems: "flex-end", textAlign: 'center' }}>{ReactHtmlParser(val.text)}</p>
                            })
                        }
                        <div >
                            <DynamicForm2
                                data={this.props.formData}
                                action={this.props.action}
                                toggle={this.toggle.bind(this)}
                                reducer="updateSeller"
                                selects={this.props.selects}
                                backFunc={this.toggle}
                                triggerType={this.props.triggerType}
                                selectKey={this.props.selectKey}
                                noReset={this.props.noReset}
                                loading={this.props.loading}
                                disabledButton={this.props.disabledButton}
                                checkboxModal={this.props.checkboxModal === undefined ? '' : this.props.checkboxModal}
                                tableModalText={this.props.tableModalText === undefined ? '' : this.props.tableModalText}
                                metricDetails={this.props.metricDetails === undefined ? false : this.props.metricDetails}
                                disableButton={this.props.disableButton !== undefined ? this.props.disableButton : false}
                                closeFunc={(data) => this.setState({ modal: data })}
                                onlyBackButton={this.props.onlyBackButton !== undefined ? this.props.onlyBackButton : false}
                                checkboxKey={this.props.checkboxKey !== undefined ? this.props.checkboxKey : null}
                                onlyCancel={this.props.onlyCancel !== undefined ? this.props.onlyCancel : undefined}
                                singleButton={this.props.singleButton !== undefined ? this.props.singleButton : undefined}
                                bottomTable={this.props.bottomTable !== undefined ? this.props.bottomTable : undefined}
                                creditModal={this.props.creditModal !== undefined ? this.props.creditModal : false}
                                rowId={this.props.rowId !== undefined ? this.props.rowId : 0}
                                cautionText={this.props.cautionText !== undefined ? this.props.cautionText : ''}
                                hardCodeSelects={this.props.hardCodeSelects !== undefined ? this.props.hardCodeSelects : undefined}
                                vviSelected={this.props.vviSelected !== undefined ? this.props.vviSelected : false}
                                heading={this.props.heading}
                            />
                        </div>

                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default ModalNew2;


// WEBPACK FOOTER //
// ./src/_components/common/ModalNew2/index.jsx